import { useIsLaptop } from '@synoptic/ui-kit/responsive/hooks.ts';
import { Skeleton } from '@synoptic/ui-kit/skeleton/skeleton.tsx';
import { streamsGrid } from '@/components/stream-list/stream-list.css.ts';

export const StreamsFeedFallback = ({ count = 12 }: { count?: number }) => {
  const isLaptop = useIsLaptop();

  return (
    <div className={streamsGrid}>
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} height={isLaptop ? 97 : 275} width={'100%'} />
      ))}
    </div>
  );
};
